export let globalRequestHeaders: { [key: string]: string } = {};

export function getRequestHeaders(type?: "json" | "form" | "pdf") {
	var tokenElementQuery = document.getElementsByName("__RequestVerificationToken");
	let headers = new Headers();
	headers.append('Accept', 'application/json, text/plain, */*');
	headers.append("X-Requested-With", "XMLHttpRequest");
	if (type === "form") {
		headers.append("Content-Type", "application/x-www-form-urlencoded");
	} else if (type == "pdf") {
		headers.append("Content-Type", "application/pdf");
	} else {
		headers.append("Content-Type", "application/json;charset=UTF-8");
	}

	for (let key in globalRequestHeaders) {
		headers.append(key, globalRequestHeaders[key]);
	}
	tokenElementQuery.forEach(tokenElement => headers.append("X-XSRF-Token", (tokenElement as HTMLInputElement).value))
	return headers;
}

export function getXsrfHeader() {
	var tokenElementQuery = document.getElementsByName("__RequestVerificationToken");
	let headers = new Headers();
	tokenElementQuery.forEach(tokenElement => headers.append("X-XSRF-Token", (tokenElement as HTMLInputElement).value))
	return headers;
}